import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/joy";
import { Clear as ClearIcon } from "@mui/icons-material";
import { OrgThemeColors } from "../../../common/types";
import ColorInput from "./ColorInput";

interface ColorsEditorProps {
  value: OrgThemeColors;
  onChange: (v: OrgThemeColors) => void;
  disabled?: boolean;
  mode?: "light" | "dark";
}

const ROWS: { field: keyof OrgThemeColors; label: string }[] = [
  { field: "text_primary",   label: "Primary text"      },
  { field: "text_secondary", label: "Secondary text"    },
  { field: "divider",        label: "Divider / borders" },
];

const PLACEHOLDERS = {
  light: { text_primary: "#171a1c", text_secondary: "#555e68", divider: "#d8dde3" },
  dark:  { text_primary: "#f0f4f8", text_secondary: "#9fa6ad", divider: "#363b42" },
};

const ColorsEditor: React.FC<ColorsEditorProps> = ({
  value,
  onChange,
  disabled,
  mode = "light",
}) => {
  const placeholders = PLACEHOLDERS[mode];
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {ROWS.map(({ field, label }) => (
        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            level="body-xs"
            sx={{ minWidth: 120, flexShrink: 0, color: "text.secondary" }}
          >
            {label}
          </Typography>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <ColorInput
              value={value[field] ?? ""}
              onChange={(hex) => onChange({ ...value, [field]: hex || undefined })}
              disabled={disabled}
              placeholder={placeholders[field]}
            />
          </Box>
          <Tooltip title="Clear (inherit theme default)" placement="top">
            <span>
              <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                disabled={disabled || !value[field]}
                onClick={() => onChange({ ...value, [field]: undefined })}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default ColorsEditor;
